import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <path d="M12 1L3 4.3V10.999C3 16.554 6.83625 21.735 12 23C17.1638 21.735 21 16.554 21 10.999V4.3L12 1ZM13.125 16.4H10.875V14.2H13.125V16.4ZM13.125 12H10.875V6.5H13.125V12Z" />,
  'UnverifiedUser',
)
